export default __webpack_public_path__ + "resources/icons/d600-580c.png";